import { testimonials } from "@/mocks/comicData";
import SectionHeading from "@/components/feature/SectionHeading";
import { heroAccent } from "@/mocks/comicData";

const values = [
  { icon: "ri-trophy-line", title: "高分严选", desc: "榜单与评分由人气与口碑共同决定，高分作品经得起检验。" },
  { icon: "ri-check-double-line", title: "完结保障", desc: "完结漫画专区标注完整话数，杜绝烂尾与断更风险。" },
  { icon: "ri-translate-2", title: "独家汉化", desc: "与多家汉化组合作，精翻速递并附译者注释。" },
  { icon: "ri-heart-3-line", title: "读者为本", desc: "持续根据读者反馈优化分类、推荐与追更体验。" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="品牌介绍与口碑"
          title="关于动漫之家漫画网"
          subtitle="一家专注做「找漫画」这件事的漫画资讯平台，让每个读者都能快速找到值得熬夜的佳作。"
        />

        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src={heroAccent}
              alt="动漫之家漫画网 - 漫画家与漫画作品"
              title="动漫之家漫画网 品牌介绍"
              className="h-[420px] w-full object-cover object-top"
            />
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              我们相信，一部好漫画值得被更多人看见
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              动漫之家漫画网创立以来，始终坚持「以内容为核心」的理念。我们聚合排行榜、
              完结漫画、分类大全与独家汉化组内容，通过每日更新的榜单和编辑甄选，
              帮助不同口味的读者快速定位想看的作品。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              无论你是热衷热血冒险的爽文党，还是偏爱悬疑国风的文艺向读者，
              在这里都能找到专属你的追漫清单。我们的内容原则很简单——
              推荐真正好看的，标注真正完结的，翻译真正用心的。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
                    <i className={v.icon}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900">{v.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-500">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14">
          <div className="mb-8 flex flex-col items-center gap-2 text-center">
            <span className="text-sm font-medium text-primary-600">读者怎么说</span>
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              来自 2,800 万读者的真实反馈
            </h3>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {testimonials.map((t) => (
              <figure key={t.id} className="flex flex-col justify-between rounded-lg border border-background-200/70 bg-background-50 p-5">
                <blockquote>
                  <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">「{t.text}」</p>
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}